import axios from 'axios';
import NProgress from 'nprogress'; // 进度条

// import qs from 'qs';
import message from '@/components/message';
import { getCookie } from '@/fe_modules/utils/cookie';
import {
  cloudBaseUrl,
  currEvn,
  saasCloudBaseUrl
} from '@/fe_modules/utils/http_help';
import { goLoginUrl } from '@/stores/ticketToToken';

declare module 'axios' {
  // 自定义的请求配置
  interface CustomRequestConfig {
    globalLoading: boolean;
    globalErrMessage: boolean;
    whiteListCode?: number[]; // code请求处理白名单
    urlType: string;
  }
  interface AxiosInstance {
    (config: AxiosRequestConfig | CustomRequestConfig): Promise<any>;
  }
}

const instance = axios.create({
  globalLoading: true,
  globalErrMessage: true,
  baseURL: cloudBaseUrl,
  timeout: 8000,
  headers: {},
  withCredentials: true, //request写入cookie
  urlType: ''
} as any);
const err = (error: any) => {
  NProgress.done();
  if (error.response) {
    const data = error.response.data;
    const token = '';
    switch (error.response.status) {
      case 403:
        message.error('系统提示：拒绝访问');
        break;
      case 520:
        if (token) {
          message.error('系统提示：很抱歉，登录已过期，请重新登录!');
        }
        break;
      case 404:
        message.error('系统提示：很抱歉，资源未找到!');
        break;
      case 504:
        message.error('系统提示：网络超时');
        break;
      case 401:
        message.error('系统提示：未授权，请重新登录');
        break;
      default:
        if (data.msg && error.config?.globalErrMessage) message.error(data.msg);
        break;
    }
  }
  return Promise.reject(error);
};

const resErr = (data: any, res: any): boolean => {
  if (
    (data.code !== undefined && data.code !== 0) ||
    (data.result !== undefined && data.result !== 0)
  ) {
    if ([400, 401].includes(data.code)) {
      goLoginUrl();
    } else {
      if (data.msg) {
        const duration = data.code === 5 ? 6 : undefined;
        res?.config?.globalErrMessage &&
          message.error({ content: data.msg, duration });
      }
    }
    return false;
  } else {
    return true;
  }
};

// 请求拦截
instance.interceptors.request.use((config: any) => {
  config.globalLoading && NProgress.start();
  // if (config.method == 'post') {
  config.headers['token'] =
    getCookie(`woordee_${currEvn}_talent_login_token`) || '';
  // }
  config.headers['user'] =
    getCookie(`woordee_${currEvn}_talent_login_user`) || '';
  if (config?.urlType == 'saas') {
    config.headers['Authorization'] = 'Basic ZG90OmRvdA=='; //pe和质控蒋老师加的验证，我也不知道为啥
    config.baseURL = saasCloudBaseUrl;
  }

  // if (config.url.includes('timeout=no')) {
  //   config.timeout = 720000;
  // }
  /* if (config.method == 'post') {
    config.headers['Content-Type'] = 'application/json';
    config.transformRequest = [
      function (data: any) {
        let ret = '';
        for (const it in data) {
          if (data[it] !== '' && data[it] !== null && data[it] !== undefined) {
            ret +=
              encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
          }
        }
        return ret;
      }
    ];
  } */

  return config;
});

// 响应拦截
instance.interceptors.response.use((res) => {
  NProgress.done();
  const data = res.data;
  const whiteListCode = (res.config as any)?.whiteListCode || [];

  // 自己处理错误信息
  if (Array.isArray(whiteListCode) && whiteListCode?.includes(data.code)) {
    return data;
  }
  if (!resErr(data, res)) {
    return Promise.reject(new Error(JSON.stringify(data)));
  }
  // 响应格式统一处理
  return data;
}, err);

export default instance;
